/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FulfillmentGroupItemDto } from './FulfillmentGroupItemDto';
import type { FulfillmentInventoryRequestDto } from './FulfillmentInventoryRequestDto';
import type { FulfillmentInventoryTransferDto } from './FulfillmentInventoryTransferDto';
import type { FulfillmentLocationDto } from './FulfillmentLocationDto';
export type SaleFulfillmentGroupResponseDto = {
    /**
     * Fulfillment group ID
     */
    id: number;
    /**
     * Group status
     */
    status: SaleFulfillmentGroupResponseDto.status;
    /**
     * Why this group failed
     */
    failureReason?: string | null;
    /**
     * Location the pieces are pulled from
     */
    sourceLocation: FulfillmentLocationDto;
    /**
     * Selling branch
     */
    destinationLocation: FulfillmentLocationDto;
    /**
     * Auto-created SOL for this group
     */
    inventoryRequest?: FulfillmentInventoryRequestDto | null;
    /**
     * Transfer created once the SOL was approved
     */
    inventoryTransfer?: FulfillmentInventoryTransferDto | null;
    /**
     * Pieces covered by this group
     */
    items: Array<FulfillmentGroupItemDto>;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
};
export namespace SaleFulfillmentGroupResponseDto {
    /**
     * Group status
     */
    export enum status {
        PENDING_SOL = 'PENDING_SOL',
        AWAITING_SOURCE = 'AWAITING_SOURCE',
        IN_TRANSIT = 'IN_TRANSIT',
        RECEIVED = 'RECEIVED',
        FAILED = 'FAILED',
    }
}

